// @flow

/* eslint-disable max-len,react/jsx-tag-spacing */
import * as React from 'react';
import classNames from 'classnames';
import * as css from './Icon.scss';

type Props = {|
	type: string,
	className?: string,
	width?: number,
	height?: number,
	color?: string,
	secondaryColor?: string,
	onClick?: Function,
|};

/**
 * @link - https://material.io/tools/icons/?style=baseline
 * @return {XML}
 */
const Icon = ({ type, className, width, height, color, secondaryColor, ...iconProps }: Props) => {
	let icon = null;
	const svgProps = {
		width,
		height,
		viewBox: `0 0 ${width || 34} ${height || 34}`,
		xmlns: 'http://www.w3.org/2000/svg',
	};

	switch (type) {
		case 'accessibility':
			icon = (
				<svg {...svgProps}>
					<g id="Group_338" transform="translate(-18 -24)">
						<rect
							id="Rectangle_299"
							width="34"
							height="34"
							rx="17"
							transform="translate(18 24)"
							fill={secondaryColor}
						/>
						<g id="XMLID_28_" transform="translate(-19.379 32)">
							<path
								id="XMLID_31_"
								d="M178.532 3.418a1.709 1.709 0 1 0-1.709-1.709 1.709 1.709 0 0 0 1.709 1.709z"
								fill={color}
								transform="translate(-124.881)"
							/>
							<path
								id="XMLID_30_"
								d="M56.292 204.681a3.777 3.777 0 1 1-5.149-4.5v-1.6a5.281 5.281 0 1 0 6.313 7.269l-.6-1.172z"
								fill={color}
								transform="translate(0 -191.581)"
							/>
							<path
								id="XMLID_29_"
								d="M191.737 128.291l-2.289-4.5a1 1 0 0 0-.894-.549h-2.931v-.668h2.523a.789.789 0 0 0 .753-.753.752.752 0 0 0-.753-.753h-2.523V118.8a1.5 1.5 0 1 0-3.01 0v4.912a1.535 1.535 0 0 0 1.535 1.535h3.791l2.01 3.952a1 1 0 1 0 1.788-.91z"
								fill={color}
								transform="translate(-130.467 -113.162)"
							/>
						</g>
					</g>
				</svg>
			);
			break;
		case 'facebook_icon':
			icon = (
				<svg xmlns="http://www.w3.org/2000/svg" width="24.5" height="24.5" viewBox="0 0 24.5 24.5">
					<g id="fb_share" transform="translate(0 0)">
						<path
							id="Path_499"
							data-name="Path 499"
							d="M1576.4,689.665a12.25,12.25,0,1,1-12.25-12.25A12.25,12.25,0,0,1,1576.4,689.665Z"
							transform="translate(-1551.897 -677.415)"
							fill="#314a7e"
						/>
						<path
							id="Path_500"
							data-name="Path 500"
							d="M1858.474,858.744h3.144V850.87h2.193l.234-2.636h-2.428v-1.5c0-.622.125-.868.726-.868h1.7v-2.736h-2.177c-2.34,0-3.395,1.03-3.395,3v2.1h-1.636v2.67h1.636Z"
							transform="translate(-1848.198 -838.434)"
							fill="#fff"
						/>
					</g>
				</svg>
			);
			break;
		case 'whatsapp_icon':
			icon = (
				<svg
					id="whatsApp_share"
					xmlns="http://www.w3.org/2000/svg"
					width="24.5"
					height="24.5"
					viewBox="0 0 24.5 24.5"
				>
					<path
						id="Path_502"
						data-name="Path 502"
						d="M602.568,2601.759a12.03,12.03,0,0,0-24.038-.219c-.006.174-.011.349-.011.523a11.842,11.842,0,0,0,1.723,6.165l-2.168,6.4,6.661-2.117a12.043,12.043,0,0,0,17.839-10.449C602.574,2601.962,602.574,2601.86,602.568,2601.759Z"
						transform="translate(-578.074 -2590.129)"
						fill="#30bf39"
					/>
					<path
						id="Path_503"
						data-name="Path 503"
						d="M724.264,2730.4c-.3-.146-1.746-.855-2.016-.951s-.467-.146-.664.146-.766.951-.935,1.143-.344.22-.642.073a7.978,7.978,0,0,1-2.371-1.453,8.75,8.75,0,0,1-1.638-2.021c-.169-.293-.017-.451.13-.6s.292-.343.445-.512l.108-.141a3.286,3.286,0,0,0,.185-.349.527.527,0,0,0-.023-.512c-.073-.146-.664-1.588-.912-2.173s-.49-.484-.664-.484-.366-.028-.563-.028a1.089,1.089,0,0,0-.788.366,3.273,3.273,0,0,0-1.031,2.443,3.7,3.7,0,0,0,.153,1,6.631,6.631,0,0,0,1.053,2.026,12.1,12.1,0,0,0,5.034,4.419c3,1.165,3,.777,3.542.726a2.939,2.939,0,0,0,1.988-1.391,2.421,2.421,0,0,0,.175-1.39C724.755,2730.62,724.557,2730.547,724.264,2730.4Z"
						transform="translate(-706.28 -2716.057)"
						fill="#fff"
					/>
				</svg>
			);
			break;
		case 'twitter_icon':
			icon = (
				<svg xmlns="http://www.w3.org/2000/svg" width="24.5" height="24.5" viewBox="0 0 24.5 24.5">
					<g id="twitter_share" data-name="twitter share" transform="translate(0)">
						<path
							id="Path_497"
							data-name="Path 497"
							d="M2733.72,2444.775c-.275,16.335-24.227,16.332-24.5,0C2709.495,2428.442,2733.447,2428.444,2733.72,2444.775Z"
							transform="translate(-2709.22 -2432.526)"
							fill="#00a9ff"
						/>
						<path
							id="Path_498"
							data-name="Path 498"
							d="M2930.952,2692.917c5.592,3.853,12.971-1.368,12.355-7.234a5.778,5.778,0,0,0,1.409-1.483,5.589,5.589,0,0,1-1.622.451,2.861,2.861,0,0,0,1.241-1.585,5.609,5.609,0,0,1-1.792.7,2.844,2.844,0,0,0-4.812,2.613,7.981,7.981,0,0,1-5.82-2.994,2.894,2.894,0,0,0,.874,3.825,2.77,2.77,0,0,1-1.28-.358,2.859,2.859,0,0,0,2.266,2.845,2.786,2.786,0,0,1-1.275.049,2.829,2.829,0,0,0,2.637,1.989A5.614,5.614,0,0,1,2930.952,2692.917Z"
							transform="translate(-2924.669 -2675.671)"
							fill="#fff"
						/>
					</g>
				</svg>
			);
			break;
		case 'email_icon':
			icon = (
				<svg
					id="email_share"
					data-name="email share"
					xmlns="http://www.w3.org/2000/svg"
					width="24.5"
					height="24.5"
					viewBox="0 0 24.5 24.5"
				>
					<path
						id="Path_499"
						data-name="Path 499"
						d="M1576.4,689.665a12.25,12.25,0,1,1-12.25-12.25A12.25,12.25,0,0,1,1576.4,689.665Z"
						transform="translate(-1551.898 -677.415)"
					/>
					<g id="email_icon" data-name="email icon" transform="translate(-1117.25 -1362.5)">
						<g
							id="Rectangle_751"
							data-name="Rectangle 751"
							transform="translate(1123 1370)"
							fill="none"
							stroke="#fff"
							strokeWidth="1.2"
						>
							<rect width="13" height="9" stroke="none" />
							<rect x="0.6" y="0.6" width="11.8" height="7.8" fill="none" />
						</g>
						<path
							id="Path_504"
							data-name="Path 504"
							d="M832.563,802.813l5.813,4.25,5.813-4.25"
							transform="translate(291.031 568)"
							fill="none"
							stroke="#fff"
							strokeWidth="1.2"
						/>
					</g>
				</svg>
			);
			break;
		case 'share':
			icon = (
				<svg xmlns="http://www.w3.org/2000/svg" width="60" height="60" viewBox="0 0 60 60">
					<g transform="translate(-18 -24)">
						<g>
							<g>
								<g>
									<g>
										<path
											fill="#fff"
											d="M9.8 11.591a5.032 5.032 0 0 1 0 2.818l9.246 4.9a3.986 3.986 0 1 1-.937 1.767l-9.247-4.9a5 5 0 1 1 0-6.352l9.247-4.9a4 4 0 1 1 .936 1.776z"
											transform="translate(33 40.998) translate(-419 -227) translate(419 227)"
										/>
									</g>
								</g>
							</g>
						</g>
					</g>
				</svg>
			);
			break;

		case 'copy_icon':
			icon = (
				<svg xmlns="http://www.w3.org/2000/svg" {...svgProps}>
					<g data-name="Group 100" transform="translate(-1230 -730)">
						<circle data-name="Ellipse 11" cx="13" cy="13" r="13" transform="translate(1230 730)" />
						<path
							data-name="Icon metro-link"
							fill={color}
							d="M8.874 10.941a.719.719 0 0 1-.51-.211 3.388 3.388 0 0 1 0-4.786l2.663-2.663a3.384 3.384 0 1 1 4.786 4.786L14.6 9.284a.721.721 0 1 1-1.02-1.02l1.217-1.217a1.942 1.942 0 0 0-2.75-2.747L9.384 6.964a1.944 1.944 0 0 0 0 2.746.721.721 0 0 1-.51 1.231zm-2.556 5.218a3.384 3.384 0 0 1-2.393-5.777l1.218-1.217a.721.721 0 0 1 1.02 1.02L4.945 11.4a1.942 1.942 0 0 0 2.746 2.746l2.663-2.663a1.944 1.944 0 0 0 0-2.746.721.721 0 1 1 1.02-1.02 3.388 3.388 0 0 1 0 4.786l-2.663 2.665a3.362 3.362 0 0 1-2.393.991z"
							transform="translate(1233.131 733.777)"
						/>
					</g>
				</svg>
			);
			break;

		case 'שער': // GOAL
		case 'שער עצמי': // OWN_GOAL
			icon = (
				<svg {...svgProps} version="1.1" id="Layer_1" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 22 22">
					{/* <style type="text/css">.st0{fill:;}	.st1{;}</style> */}
					<g>
						<linearGradient
							id="GOAL"
							gradientUnits="userSpaceOnUse"
							x1="1934.5321"
							y1="1015.9855"
							x2="1956.5267"
							y2="1015.9855"
							gradientTransform="matrix(0.2551 -0.9669 0.9669 0.2551 -1467.6105 1633.0427)"
						>
							<stop offset="0" style={{ stopColor: '#000000' }} />
							<stop offset="0.5645" style={{ stopColor: '#363636' }} />
							<stop offset="1" style={{ stopColor: '#000000' }} />
						</linearGradient>
						<circle className="st0" cx="11" cy="11" r="11" fill="url(#GOAL)" />
						<g>
							<path
								className="st1"
								fill="#FEFEFE"
								d="M13.6,7.4c-1.2-0.3-2.5-0.6-3.7-0.8C9.8,6.5,9.7,6.6,9.6,6.7c-1,1-1.9,2-2.8,3c-0.1,0.1-0.1,0.2-0.1,0.4 c0.3,1.4,0.7,2.7,1.2,4c0,0.1,0.1,0.2,0.2,0.2c1.3,0.4,2.7,0.8,4,1.1c0.1,0,0.2,0,0.3-0.1c1-1,2-2,3-3.1c0.1-0.1,0.1-0.2,0.1-0.4 c-0.4-1.2-0.8-2.4-1.1-3.6C14.4,7.7,14.1,7.5,13.6,7.4z"
							/>
							<path
								className="st1"
								fill="#FEFEFE"
								d="M2.6,16c0.9,0.6,1.9,1,2.9,1.2c0.2,0,0.2-0.1,0.3-0.1c0.6-0.8,1.2-1.7,1.8-2.5c0.1-0.1,0.1-0.3,0.1-0.4 c-0.5-1.3-0.9-2.6-1.2-4c0-0.2-0.1-0.3-0.2-0.3C5.3,9.4,4.3,9,3.3,8.7C3.2,8.6,3.1,8.6,3,8.7c-0.7,0.8-1.2,1.7-1.7,2.6 c0,0.1-0.1,0.2-0.1,0.3c0,0,0,0.1,0,0.1c0.1,1.4,0.5,2.6,1.1,3.9C2.4,15.8,2.5,15.9,2.6,16z"
							/>
							<path
								className="st1"
								fill="#FEFEFE"
								d="M18.8,12.5c-0.9-0.1-1.8-0.2-2.7-0.3c-0.2,0-0.3,0-0.4,0.1c-0.9,1.1-1.9,2.2-3,3.2c-0.1,0.1-0.1,0.1-0.1,0.2 c0.2,1,0.3,2,0.4,3c0,0.2,0.1,0.2,0.2,0.3c0.6,0.2,1.3,0.3,1.9,0.3c0.2,0,0.4,0,0.6,0c0.4,0,0.8-0.2,1.1-0.5 c1-0.8,1.8-1.7,2.5-2.8c0.1-0.1,0.1-0.2,0.1-0.4c0.1-0.9-0.1-1.8-0.2-2.8C19.3,12.6,19.1,12.5,18.8,12.5z"
							/>
							<path
								className="st1"
								fill="#FEFEFE"
								d="M8.7,2.9C8.5,3.1,8.5,3.2,8.6,3.3C9,4.2,9.4,5.1,9.7,6c0.1,0.2,0.2,0.3,0.3,0.3c1.4,0.2,2.7,0.5,4.1,0.9 c0.2,0,0.3,0,0.4-0.1c0.7-0.7,1.4-1.3,2.2-1.8c0.1-0.1,0.2-0.2,0.1-0.3c-0.3-0.9-0.6-1.8-1.2-2.7c-0.1-0.1-0.1-0.2-0.3-0.2 c-1.3-0.6-2.6-0.9-4-1c-0.2,0-0.3,0-0.5,0.1C10,1.7,9.3,2.2,8.7,2.9z"
							/>
							<path
								className="st1"
								fill="#FEFEFE"
								d="M2.9,8.1C3,7,3.2,6,3.7,5.1c0.3-0.6,0.2-1-0.3-1.4c0,0-0.1-0.1-0.1-0.1c0,0,0,0-0.1-0.1 c0,0.1-0.1,0.1-0.1,0.2c-1.7,1.9-2.6,4-2.8,6.5c0,0.5,0.1,0.7,0.5,1c0.2,0.1,0.2,0.1,0.3-0.1c0.5-0.9,1-1.8,1.7-2.6 C2.9,8.4,2.9,8.3,2.9,8.1z"
							/>
							<path
								className="st1"
								fill="#FEFEFE"
								d="M8.4,20.2c-0.9-0.7-1.8-1.5-2.6-2.4c-0.1-0.2-0.3-0.3-0.5-0.3c-0.9-0.2-1.7-0.5-2.5-1 c-0.1-0.1-0.3-0.3-0.5-0.2c-0.1,0.1-0.1,0.3-0.2,0.5c0,0,0,0,0,0.1c0,0.1,0.1,0.2,0.1,0.3c1.4,1.9,3.2,3.2,5.4,4 c0.2,0.1,0.4,0.2,0.6,0.1c0.2-0.1,0.1-0.3,0.2-0.5c0-0.1,0-0.2,0.1-0.2C8.6,20.4,8.5,20.3,8.4,20.2z"
							/>
							<path
								className="st1"
								fill="#FEFEFE"
								d="M3.7,3.6C3.9,3.7,4,3.9,4.1,4.1c0.1,0.1,0.1,0.1,0.2,0c1-0.6,2.2-0.9,3.4-1.1c0.2,0,0.4,0,0.6-0.2 c0.7-0.8,1.5-1.4,2.4-2c0,0,0.1,0,0.1-0.1c-0.1-0.1-0.5-0.5-0.7-0.5c0,0,0,0-0.1,0C7.6,0.5,5.5,1.5,3.7,3.1 C3.5,3.3,3.5,3.4,3.7,3.6z"
							/>
							<path
								className="st1"
								fill="#FEFEFE"
								d="M17.2,5c0,0.1,0.1,0.2,0.2,0.2c1.1,0.7,2,1.7,2.8,2.7c0,0.1,0.1,0.2,0.2,0.1C20.5,8,20.8,8,21,8 c0.2,0,0.3-0.1,0.2-0.3C20.4,5.3,19,3.4,16.9,2c-0.3-0.2-0.5-0.2-0.8-0.1C15.9,2,15.9,2.1,16,2.3C16.5,3.1,16.9,4,17.2,5z"
							/>
							<path
								className="st1"
								fill="#FEFEFE"
								d="M16.2,19.5c-1.1,0.2-2.1,0.1-3.1-0.2c-0.1,0-0.1,0-0.2,0c-1,0.5-2.1,0.8-3.3,0.9c-0.6,0.1-0.8,0.4-0.9,0.9 c0,0.2,0,0.2,0.2,0.2c0.7,0.1,1.5,0.2,2.2,0.2c1.7,0,3.3-0.4,4.8-1.1c0.4-0.2,0.5-0.5,0.6-0.9C16.4,19.5,16.3,19.5,16.2,19.5z"
							/>
							<path
								className="st1"
								fill="#FEFEFE"
								d="M21.4,8.4c0-0.2-0.1-0.2-0.3-0.2c-0.2,0.1-0.4,0.1-0.7,0.1c-0.1,0-0.2,0.1-0.2,0.2c-0.1,1.3-0.3,2.5-0.7,3.7 c0,0.1-0.1,0.2,0,0.3c0.3,1,0.4,2,0.4,3.1c0,0.1,0,0.1,0.1,0.2c0.2,0.1,0.7-0.1,0.8-0.3c0.6-1.4,1-2.9,1-4.5 C21.7,10.1,21.6,9.3,21.4,8.4z"
							/>
						</g>
					</g>
				</svg>
			);
			break;

		case 'החלטת שופט': // JUDGES_DECISION
		case 'החלטת השופט': // JUDGES_DECISION_V2
			icon = (
				<svg {...svgProps} id="Layer_1" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 22 22">
					<g>
						<path
							className="st0"
							fill="#1C2F40"
							d="M19,5.7c0.4-0.7,1.7-1.4,1.7-1.4s0.1,0-0.9-0.4c-0.4-0.1-0.9-0.1-1.2,0.2c-0.1,0.1-1,0.8-1.1,0.9
		c-1-0.5-2.2-1.1-3-1.5c-1.4-0.6-3.2-1-5.5,1.4C6.9,7.3,0,15,0,15l4.6,2.4l11.6-11C16.1,6.4,17.7,5.1,19,5.7L19,5.7z M12.3,8.8
		L8,6.8c0,0,2.2-2.5,2.9-3l4.2,2C15.1,5.9,12.8,8.2,12.3,8.8L12.3,8.8z M12.3,8.8"
						/>
						<path
							className="st0"
							fill="#1C2F40"
							d="M22,5.9c-0.1-0.8-0.5-1.4-0.9-1.2c-0.9,0.5-1.4,1.2-1.6,1.5c-0.2-0.1-0.3-0.1-0.5-0.1
		c-1.2-0.1-2.2,0.7-2.3,0.8l-11.5,11l1.8,1.1c0,0,4.4-4,7.1-3.3c0.1,0.1,0.3,0.2,0.4,0.3c1.9,0.9,4.5-0.6,5.8-3.4c0.5-1,0.7-2,0.7-3
		c0-0.4,0-0.8-0.1-1.2c0.1-0.1,0.3-0.3,0.5-0.5C22.1,7.1,22,5.9,22,5.9z M21.2,6.9c-0.2,0-0.4-0.3-0.4-0.6c0-0.3,0.2-0.6,0.4-0.6
		c0.2,0,0.4,0.4,0.4,0.6C21.6,6.5,21.4,6.9,21.2,6.9L21.2,6.9z M21.2,6.9"
						/>
						<path
							className="st1"
							style={{ opacity: 0.5 }}
							d="M22,5.9c-0.1-0.8-0.5-1.4-0.9-1.2c-0.9,0.5-1.4,1.2-1.6,1.5c-0.2-0.1-0.3-0.1-0.5-0.1
		c-1.2-0.1-2.2,0.7-2.3,0.8l-11.5,11l1.8,1.1c0,0,4.4-4,7.1-3.3c0.1,0.1,0.3,0.2,0.4,0.3c1.9,0.9,4.5-0.6,5.8-3.4c0.5-1,0.7-2,0.7-3
		c0-0.4,0-0.8-0.1-1.2c0.1-0.1,0.3-0.3,0.5-0.5C22.1,7.1,22,5.9,22,5.9z M21.2,6.9c-0.2,0-0.4-0.3-0.4-0.6c0-0.3,0.2-0.6,0.4-0.6
		c0.2,0,0.4,0.4,0.4,0.6C21.6,6.5,21.4,6.9,21.2,6.9L21.2,6.9z M21.2,6.9"
						/>
					</g>
				</svg>
			);
			break;

		case 'פציעה': // INJURY
			icon = (
				<svg
					{...svgProps}
					width="20"
					height="20"
					viewBox="0 0 23 20"
					fill="none"
					xmlns="http://www.w3.org/2000/svg"
				>
					<rect y="5" width="23" height="15" rx="1" fill="#D30603" />
					<path
						fillRule="evenodd"
						clipRule="evenodd"
						d="M4 2.5C4 1.39543 4.89543 0.5 6 0.5H18C19.1046 0.5 20 1.39543 20 2.5V5.5H18V2.5H6V5.5H4V2.5Z"
						fill="#D30603"
					/>
					<rect x="10" y="8" width="3" height="9" fill="white" />
					<rect x="7" y="14" width="3" height="9" transform="rotate(-90 7 14)" fill="white" />
				</svg>
			);
			break;

		case 'החמצה': // MISSED_THE_GATE
			icon = (
				<svg {...svgProps} id="Layer_1" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 22 22">
					<g>
						<g>
							<linearGradient
								id="MISSED_THE_GATE"
								gradientUnits="userSpaceOnUse"
								x1="1935.2205"
								y1="1015.0918"
								x2="1955.3669"
								y2="1015.0918"
								gradientTransform="matrix(0.2551 -0.9669 0.9669 0.2551 -1467.6105 1633.0427)"
							>
								<stop offset="0" style={{ stopColor: '#000000' }} />
								<stop offset="0.5645" style={{ stopColor: '#363636' }} />
								<stop offset="1" style={{ stopColor: '#000000' }} />
							</linearGradient>
							<circle className="st0" fill="url(#MISSED_THE_GATE)" cx="10.1" cy="11" r="10.1" />
							<g>
								<path
									className="st1"
									fill="#FEFEFE"
									d="M12.5,7.7C11.3,7.4,10.2,7.1,9,6.9C8.9,6.9,8.9,7,8.8,7.1C7.9,7.9,7.1,8.9,6.3,9.8C6.2,9.9,6.2,10,6.2,10.2
				c0.3,1.3,0.6,2.5,1.1,3.7c0,0.1,0.1,0.2,0.2,0.2c1.2,0.4,2.4,0.7,3.7,1c0.1,0,0.2,0,0.3-0.1c1-0.9,1.9-1.8,2.7-2.8
				c0.1-0.1,0.1-0.2,0.1-0.4c-0.3-1.1-0.7-2.2-1-3.3C13.1,8,12.9,7.8,12.5,7.7z"
								/>
								<path
									className="st1"
									fill="#FEFEFE"
									d="M2.4,15.6c0.8,0.6,1.7,0.9,2.6,1.1c0.2,0,0.2,0,0.2-0.1C5.8,15.8,6.4,15,7,14.3c0.1-0.1,0.1-0.2,0-0.4
				c-0.5-1.2-0.8-2.4-1.1-3.6c0-0.1-0.1-0.2-0.2-0.3C4.8,9.5,3.9,9.2,3,8.9c-0.1,0-0.2,0-0.3,0.1c-0.6,0.8-1.1,1.6-1.6,2.4
				c0,0.1-0.1,0.2-0.1,0.2c0,0,0,0.1,0,0.1c0.1,1.2,0.5,2.4,1,3.5C2.2,15.4,2.3,15.5,2.4,15.6z"
								/>
								<path
									className="st1"
									fill="#FEFEFE"
									d="M17.2,12.4c-0.8-0.1-1.7-0.1-2.5-0.2c-0.2,0-0.2,0-0.3,0.1c-0.9,1-1.8,2-2.8,2.9c-0.1,0.1-0.1,0.1-0.1,0.2
				c0.2,0.9,0.3,1.8,0.4,2.7c0,0.1,0.1,0.2,0.2,0.3c0.6,0.2,1.2,0.2,1.7,0.2c0.2,0,0.4,0,0.6,0c0.4,0,0.7-0.2,1.1-0.4
				c0.9-0.7,1.7-1.6,2.3-2.5c0.1-0.1,0.1-0.2,0.1-0.3c0.1-0.9-0.1-1.7-0.2-2.5C17.7,12.5,17.5,12.4,17.2,12.4z"
								/>
								<path
									className="st1"
									fill="#FEFEFE"
									d="M7.9,3.6C7.8,3.7,7.8,3.8,7.9,4c0.4,0.8,0.8,1.6,1,2.5C9,6.6,9.1,6.7,9.2,6.7c1.3,0.2,2.5,0.5,3.7,0.8
				c0.1,0,0.2,0,0.3-0.1c0.6-0.6,1.3-1.2,2-1.7c0.1-0.1,0.2-0.2,0.1-0.3c-0.2-0.9-0.6-1.7-1.1-2.4c-0.1-0.1-0.1-0.2-0.2-0.2
				c-1.2-0.5-2.4-0.8-3.7-0.9c-0.2,0-0.3,0-0.5,0.1C9.2,2.4,8.5,3,7.9,3.6z"
								/>
								<path
									className="st1"
									fill="#FEFEFE"
									d="M2.7,8.3C2.8,7.4,3,6.4,3.4,5.6c0.3-0.5,0.2-0.9-0.2-1.2c0,0-0.1-0.1-0.1-0.1c0,0,0,0-0.1-0.1
				c0,0,0,0.1-0.1,0.2C1.3,6,0.5,8,0.3,10.3c0,0.4,0.1,0.7,0.4,0.9c0.1,0.1,0.2,0.1,0.3-0.1c0.4-0.8,0.9-1.6,1.5-2.3
				C2.6,8.6,2.7,8.5,2.7,8.3z"
								/>
								<path
									className="st1"
									fill="#FEFEFE"
									d="M7.7,19.4C6.8,18.8,6,18,5.3,17.2C5.2,17,5.1,17,4.9,16.9C4,16.7,3.3,16.4,2.5,16c-0.1-0.1-0.3-0.3-0.4-0.2
				C2,15.9,2,16.1,2,16.3c0,0,0,0,0,0.1c0,0.1,0.1,0.2,0.1,0.3c1.3,1.7,2.9,3,4.9,3.6c0.2,0.1,0.4,0.2,0.5,0.1
				c0.1-0.1,0.1-0.3,0.2-0.5c0-0.1,0-0.2,0.1-0.2C7.9,19.6,7.8,19.5,7.7,19.4z"
								/>
								<path
									className="st1"
									fill="#FEFEFE"
									d="M3.4,4.2c0.1,0.1,0.2,0.3,0.3,0.4c0.1,0.1,0.1,0.1,0.2,0c1-0.6,2-0.8,3.1-1c0.2,0,0.4,0,0.6-0.2
				C8.3,2.8,9,2.2,9.8,1.7c0,0,0.1,0,0.1-0.1C9.8,1.5,9.4,1.2,9.3,1.2c0,0,0,0-0.1,0C7,1.4,5.1,2.3,3.4,3.8C3.2,3.9,3.2,4.1,3.4,4.2
				z"
								/>
								<path
									className="st1"
									fill="#FEFEFE"
									d="M15.7,5.5c0,0.1,0.1,0.2,0.2,0.2c1,0.7,1.8,1.5,2.6,2.5c0,0.1,0.1,0.1,0.2,0.1c0.2,0,0.4-0.1,0.6-0.1
				c0.2,0,0.2-0.1,0.2-0.3c-0.7-2.2-2-3.9-3.9-5.2c-0.3-0.2-0.5-0.2-0.7-0.1c-0.2,0.1-0.2,0.1-0.1,0.3C15.1,3.8,15.5,4.6,15.7,5.5z"
								/>
								<path
									className="st1"
									fill="#FEFEFE"
									d="M14.8,18.8c-1,0.2-1.9,0.1-2.9-0.2c-0.1,0-0.1,0-0.2,0c-1,0.4-2,0.7-3,0.9c-0.6,0.1-0.8,0.3-0.8,0.8
				c0,0.2,0,0.2,0.2,0.2c0.7,0.1,1.4,0.2,2,0.2c1.6,0,3-0.3,4.4-1c0.3-0.2,0.5-0.4,0.5-0.8C15,18.8,15,18.8,14.8,18.8z"
								/>
								<path
									className="st1"
									fill="#FEFEFE"
									d="M19.6,8.6c0-0.1-0.1-0.2-0.2-0.2c-0.2,0.1-0.4,0.1-0.6,0.1c-0.1,0-0.1,0.1-0.1,0.2c-0.1,1.2-0.3,2.3-0.7,3.4
				c0,0.1-0.1,0.2,0,0.3c0.3,0.9,0.4,1.9,0.3,2.8c0,0.1,0,0.1,0.1,0.1c0.2,0.1,0.6-0.1,0.7-0.3c0.6-1.3,0.9-2.6,0.9-4.1
				C19.9,10.2,19.8,9.4,19.6,8.6z"
								/>
							</g>
						</g>
						<polygon
							className="st2"
							fill="#FF0000"
							points="22,13.2 20.8,12 18,14.8 15.2,11.9 14,13.1 16.7,16 13.9,18.7 15.1,19.9 17.9,17.2 20.7,20 21.9,18.8
		19.2,16 	"
						/>
					</g>
				</svg>
			);
			break;

		case 'נבדל': // OFFSIDE (FLAG)
			icon = (
				<svg {...svgProps} id="Layer_1" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 22 22">
					<g>
						<path d="M4.3,22L4.3,22c-0.2,0-0.5-0.2-0.5-0.5V0.6c0-0.2,0.2-0.5,0.5-0.5h0c0.2,0,0.5,0.2,0.5,0.5v20.9C4.8,21.8,4.6,22,4.3,22z" />
						<path d="M4.3,22L4.3,22c-0.4,0-0.8-0.4-0.8-0.8v-5.4c0-0.4,0.4-0.8,0.8-0.8h0c0.4,0,0.8,0.4,0.8,0.8v5.4C5.1,21.6,4.7,22,4.3,22z" />
						<g>
							<path
								className="st0"
								fill="#F4E447"
								d="M4.8,1c0,0,2.5,1.4,6.9-0.2v4.9c0,0-3.8,1.8-6.9,0V1z"
							/>
							<path
								className="st1"
								fill="#D32F38"
								d="M11.6,5.7c0,0,2.5-1.6,6.9,0V0.8c0,0-3.8-1.8-6.9,0V5.7z"
							/>
							<path
								className="st1"
								fill="#D32F38"
								d="M4.8,5.7c0,0,2.5,1.6,6.9,0v5c0,0-3.8,1.8-6.9,0V5.7z"
							/>
							<path
								className="st0"
								fill="#F4E447"
								d="M11.6,10.7c0,0,2.5-1.6,6.9,0v-5c0,0-3.8-1.7-6.9,0L11.6,10.7z"
							/>
						</g>
					</g>
				</svg>
			);
			break;

		case 'אחר': // OTHER (STAR)
			icon = (
				<svg {...svgProps} id="Layer_1" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 22 22">
					<polygon
						className="st0"
						fill="#1C2F40"
						points="11,0.5 14.4,7.4 22,8.5 16.5,13.9 17.8,21.5 11,17.9 4.2,21.5 5.5,13.9 0,8.5 7.6,7.4 "
					/>
				</svg>
			);
			break;

		case 'שער בפנדל': // PENALTY_GOAL
			icon = (
				<svg {...svgProps} version="1.1" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 22 22">
					<g>
						<linearGradient
							id="PENALTY_GOAL"
							gradientUnits="userSpaceOnUse"
							x1="1934.5631"
							y1="1015.4767"
							x2="1955.2584"
							y2="1015.4767"
							gradientTransform="matrix(0.2551 -0.9669 0.9669 0.2551 -1467.6105 1633.0427)"
						>
							<stop offset="0" style={{ stopColor: '#000000' }} />
							<stop offset="0.5645" style={{ stopColor: '#363636' }} />
							<stop offset="1" style={{ stopColor: '#000000' }} />
						</linearGradient>
						<path
							className="st0"
							fill="url(#PENALTY_GOAL)"
							d="M20.4,11.3c0,0,0,0.1,0,0.1c0,1.5-0.3,2.9-0.9,4.2c-0.1,0.2-0.5,0.4-0.7,0.3c-0.1,0-0.1-0.1-0.1-0.1 c0-1-0.1-1.9-0.3-2.9c0-0.1,0-0.2,0-0.2c-0.2,0.1-0.4,0.2-0.6,0.2c0.2,0,0.3,0.1,0.4,0.4c0.2,0.9,0.3,1.7,0.2,2.6 c0,0.1-0.1,0.2-0.1,0.3c-0.6,1-1.4,1.9-2.4,2.6c-0.3,0.3-0.7,0.4-1.1,0.4c-0.2,0-0.4,0-0.6,0c-0.6,0-1.2-0.1-1.8-0.2 c-0.2,0-0.2-0.1-0.2-0.3c-0.1-0.9-0.2-1.9-0.4-2.8c0-0.1,0-0.2,0.1-0.2c0.9-0.8,1.7-1.7,2.5-2.6c-0.1,0-0.2,0-0.3-0.1 c-0.7,0.9-1.5,1.7-2.4,2.5c-0.1,0.1-0.2,0.1-0.3,0.1c-1.3-0.3-2.5-0.6-3.8-1c-0.1,0-0.2-0.1-0.2-0.2c-0.5-1.2-0.9-2.5-1.1-3.8 c0-0.1,0-0.3,0.1-0.4c0.8-1,1.7-1.9,2.6-2.8c0,0,0,0,0,0C9,7.1,9,6.9,9,6.6c0-0.1,0-0.1,0-0.2C8.8,5.7,8.4,4.9,8.1,4.3 C8,4.1,8,4,8.1,3.9c0.6-0.6,1.3-1.2,2-1.6c0.2-0.1,0.3-0.2,0.5-0.1c0,0,0.1,0,0.1,0c0.3-0.3,0.6-0.6,1-0.9C6.6,0.5,1.7,3.7,0.3,8.8 C-1.1,14.4,2.2,20,7.7,21.5c5.5,1.5,11.2-1.8,12.6-7.4c0.3-1,0.4-2.1,0.3-3.1C20.6,11.1,20.5,11.2,20.4,11.3z M3.5,4 c1.7-1.5,3.7-2.4,5.9-2.6c0,0,0,0,0.1,0c0.1,0,0.6,0.3,0.6,0.4c0,0.1,0,0.1-0.1,0.1C9.2,2.4,8.5,3.1,7.8,3.8C7.7,4,7.5,3.9,7.3,4 C6.1,4.2,5.1,4.4,4.1,5C4,5.1,3.9,5,3.8,5C3.7,4.8,3.6,4.6,3.5,4.5C3.3,4.3,3.3,4.2,3.5,4z M0.7,11.7c-0.3-0.2-0.5-0.5-0.5-0.9 c0.2-2.3,1.1-4.4,2.6-6.1C3,4.6,3,4.5,3,4.5c0.1,0.1,0.1,0.1,0.1,0.1c0,0,0.1,0.1,0.1,0.1C3.7,5,3.8,5.4,3.5,5.9 C3,6.8,2.9,7.7,2.8,8.7c0,0.2-0.1,0.3-0.2,0.5C2,9.9,1.4,10.7,1,11.6C0.9,11.8,0.9,11.8,0.7,11.7z M1.1,12.1c0-0.1,0-0.2,0.1-0.3 c0.4-0.9,1-1.7,1.6-2.5C2.9,9.2,3,9.2,3.1,9.3C4,9.6,5,10,5.9,10.4c0.1,0.1,0.2,0.1,0.2,0.3c0.3,1.3,0.6,2.5,1.1,3.7 c0.1,0.2,0.1,0.3-0.1,0.4c-0.6,0.8-1.2,1.5-1.7,2.3c-0.1,0.1-0.1,0.2-0.2,0.1c-1-0.2-1.9-0.6-2.7-1.1c-0.1-0.1-0.2-0.2-0.3-0.3 c-0.6-1.2-0.9-2.4-1-3.6C1.1,12.2,1.1,12.1,1.1,12.1z M8,20.4c0,0.1,0,0.2-0.1,0.2c-0.1,0.2,0,0.4-0.2,0.5 c-0.1,0.1-0.4-0.1-0.5-0.1c-2.1-0.7-3.8-1.9-5.1-3.7C2.1,17.2,2,17.1,2,17c0,0,0,0,0-0.1c0-0.2,0-0.4,0.2-0.5 c0.2-0.1,0.3,0.1,0.4,0.2C3.4,17,4.2,17.3,5,17.5c0.2,0,0.4,0.1,0.5,0.3c0.7,0.9,1.5,1.6,2.4,2.3C8,20.2,8.1,20.3,8,20.4z M15.4,19.7c-0.1,0.4-0.2,0.6-0.5,0.8c-1.4,0.7-2.9,1-4.5,1c-0.7,0-1.4-0.1-2.1-0.2c-0.1,0-0.2-0.1-0.2-0.2 c0.1-0.5,0.3-0.8,0.9-0.9c1.1-0.1,2.1-0.4,3.1-0.9c0.1,0,0.1,0,0.2,0c1,0.3,1.9,0.4,2.9,0.2C15.4,19.5,15.4,19.5,15.4,19.7z"
						/>
						<path
							className="st1"
							fill="#FEFEFE"
							d="M9.1,7.4C9.1,7.4,9.1,7.4,9.1,7.4c-0.9,0.9-1.8,1.9-2.6,2.8c-0.1,0.1-0.1,0.2-0.1,0.4c0.3,1.3,0.6,2.5,1.1,3.8 c0,0.1,0.1,0.2,0.2,0.2c1.2,0.4,2.5,0.7,3.8,1c0.1,0,0.2,0,0.3-0.1c0.8-0.8,1.6-1.6,2.4-2.5C11.5,12.4,9.4,10.2,9.1,7.4z"
						/>
						<path
							className="st1"
							fill="#FEFEFE"
							d="M2.4,16.1c0.8,0.6,1.8,0.9,2.7,1.1c0.2,0,0.2,0,0.2-0.1c0.6-0.8,1.1-1.6,1.7-2.3c0.1-0.1,0.1-0.3,0.1-0.4 c-0.5-1.2-0.9-2.5-1.1-3.7c0-0.2-0.1-0.2-0.2-0.3C5,10,4,9.6,3.1,9.3C3,9.2,2.9,9.2,2.8,9.3c-0.6,0.8-1.2,1.6-1.6,2.5 c0,0.1-0.1,0.2-0.1,0.3c0,0,0,0.1,0,0.1c0.1,1.3,0.5,2.5,1,3.6C2.2,16,2.3,16.1,2.4,16.1z"
						/>
						<path
							className="st1"
							fill="#FEFEFE"
							d="M14.5,13.1c-0.8,0.9-1.6,1.8-2.5,2.6c-0.1,0.1-0.1,0.1-0.1,0.2c0.2,0.9,0.3,1.9,0.4,2.8c0,0.2,0.1,0.2,0.2,0.3 c0.6,0.2,1.2,0.2,1.8,0.2c0.2,0,0.4,0,0.6,0c0.4,0,0.8-0.2,1.1-0.4c0.9-0.7,1.7-1.6,2.4-2.6c0.1-0.1,0.1-0.2,0.1-0.3 c0.1-0.9-0.1-1.7-0.2-2.6c-0.1-0.3-0.2-0.4-0.4-0.4c-0.7,0.2-1.4,0.3-2.1,0.3C15.3,13.2,14.9,13.2,14.5,13.1z"
						/>
						<path
							className="st1"
							fill="#FEFEFE"
							d="M10.7,2.1c-0.2,0-0.3,0-0.5,0.1c-0.8,0.5-1.4,1-2,1.6C8,4,8,4.1,8.1,4.3C8.4,4.9,8.8,5.7,9,6.4 C9.1,4.7,9.7,3.2,10.7,2.1C10.7,2.1,10.7,2.1,10.7,2.1z"
						/>
						<path
							className="st1"
							fill="#FEFEFE"
							d="M2.8,8.7c0.1-1,0.3-1.9,0.7-2.8C3.8,5.4,3.7,5,3.2,4.7c0,0-0.1-0.1-0.1-0.1c0,0,0,0-0.1-0.1 c0,0.1,0,0.1-0.1,0.2c-1.6,1.7-2.4,3.8-2.6,6.1c0,0.4,0.1,0.7,0.5,0.9c0.1,0.1,0.2,0.1,0.3-0.1c0.4-0.9,1-1.7,1.6-2.4 C2.7,9,2.8,8.9,2.8,8.7z"
						/>
						<path
							className="st1"
							fill="#FEFEFE"
							d="M7.9,20.1c-0.9-0.7-1.7-1.4-2.4-2.3c-0.1-0.2-0.3-0.2-0.5-0.3c-0.8-0.2-1.6-0.5-2.4-0.9 c-0.1-0.1-0.3-0.3-0.4-0.2C2.1,16.5,2,16.7,2,16.9c0,0,0,0,0,0.1c0,0.1,0.1,0.2,0.1,0.3c1.3,1.8,3,3,5.1,3.7 c0.2,0.1,0.4,0.2,0.5,0.1c0.1-0.1,0.1-0.3,0.2-0.5c0-0.1,0-0.2,0.1-0.2C8.1,20.3,8,20.2,7.9,20.1z"
						/>
						<path
							className="st1"
							fill="#FEFEFE"
							d="M3.5,4.5C3.6,4.6,3.7,4.8,3.8,5C3.9,5,4,5.1,4.1,5c1-0.6,2.1-0.9,3.2-1c0.2,0,0.4,0,0.6-0.2 C8.5,3.1,9.2,2.4,10.1,2c0,0,0.1,0,0.1-0.1c-0.1-0.1-0.5-0.4-0.6-0.4c0,0,0,0-0.1,0C7.2,1.6,5.2,2.5,3.5,4C3.3,4.2,3.3,4.3,3.5,4.5 z"
						/>
						<path
							className="st1"
							fill="#FEFEFE"
							d="M15.2,19.5c-1,0.2-2,0.1-2.9-0.2c-0.1,0-0.1,0-0.2,0c-1,0.4-2,0.8-3.1,0.9c-0.6,0.1-0.8,0.3-0.9,0.9 c0,0.2,0,0.2,0.2,0.2c0.7,0.1,1.4,0.2,2.1,0.2c1.6,0,3.1-0.3,4.5-1c0.4-0.2,0.5-0.5,0.5-0.8C15.4,19.5,15.4,19.5,15.2,19.5z"
						/>
						<path
							className="st1"
							fill="#FEFEFE"
							d="M18.4,12.7c0,0.1-0.1,0.1,0,0.2c0.3,0.9,0.4,1.9,0.3,2.9c0,0.1,0,0.1,0.1,0.1c0.2,0.1,0.6-0.1,0.7-0.3 c0.6-1.3,0.9-2.7,0.9-4.2c0,0,0-0.1,0-0.1C19.8,11.9,19.2,12.3,18.4,12.7z"
						/>
						{/** fill="#161616" */}
						<circle className="st2" cx="15.7" cy="6.6" r="6.3" />
						<text
							transform="matrix(1 0 0 1 20 11.25)"
							className="st3 st4 st5"
							fill="#FFFFFF"
							style={{ fontFamily: 'Arial-BoldMT', fontStyle: 'normal', fontSize: '12px' }}
						>
							P
						</text>
					</g>
				</svg>
			);
			break;

		case 'חילוף': // SUBSTITUTION
			icon = (
				<svg {...svgProps} id="Layer_1" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 22 22">
					<g>
						<polygon
							className="st0"
							fill="#F91616"
							points="0,11.4 6.3,21.2 12.6,11.4 8.1,11.4 8.1,1.5 4.5,1.5 4.5,11.4 	"
						/>
						<polygon
							className="st1"
							fill="#47A336"
							points="22,10.6 15.7,0.8 9.4,10.6 13.9,10.6 13.9,20.5 17.5,20.5 17.5,10.6 	"
						/>
					</g>
				</svg>
			);
			break;

		case 'כרטיס צהוב': // YELLOW_CARD
		case 'כרטיס צהוב שני': // SECOND_YELLOW_CARD
			icon = (
				<svg {...svgProps} id="Layer_1" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 22 22">
					<linearGradient
						id="YELLOW_CARD"
						gradientUnits="userSpaceOnUse"
						x1="0.6486"
						y1="19.6859"
						x2="21.3514"
						y2="2.3141"
					>
						<stop offset="0" style={{ stopColor: '#E2C216' }} />
						<stop offset="0.1698" style={{ stopColor: '#E8CC18' }} />
						<stop offset="0.6866" style={{ stopColor: '#F7E51F' }} />
						<stop offset="1" style={{ stopColor: '#FCEE21' }} />
					</linearGradient>
					<rect x="2.6" className="st0" fill="url(#YELLOW_CARD)" width="16.8" height="22" />
				</svg>
			);
			break;
		case 'כרטיס אדום': // RED_CARD
			icon = (
				<svg {...svgProps} version="1.1" id="Layer_1" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 22 22">
					<linearGradient
						id="RED_CARD"
						gradientUnits="userSpaceOnUse"
						x1="0.6486"
						y1="19.6859"
						x2="21.3514"
						y2="2.3141"
					>
						<stop offset="0" style={{ stopColor: '#B30000' }} />
						<stop offset="1" style={{ stopColor: '#FF0000' }} />
					</linearGradient>
					<rect x="2.6" className="st0" fill="url(#RED_CARD)" width="16.8" height="22" />
				</svg>
			);
			break;

		case 'החמצת פנדל': // MISSED_THE_GATE_FROM_PENALTY
			icon = (
				<svg {...svgProps} id="penalty_miss" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 26.978 27.545">
					<defs>
						<linearGradient
							id="linear-gradient"
							x1="93.643"
							y1="49.038"
							x2="94.645"
							y2="49.038"
							gradientUnits="objectBoundingBox"
						>
							<stop offset="0" />
							<stop offset="0.564" stopColor="#363636" />
							<stop offset="1" />
						</linearGradient>
					</defs>
					<path
						id="Path_57"
						data-name="Path 57"
						d="M25,13.578V13.7a12.128,12.128,0,0,1-1.1,5.145.824.824,0,0,1-.858.368.12.12,0,0,1-.123-.123,17.493,17.493,0,0,0-.368-3.553v-.245a1.741,1.741,0,0,1-.735.245c.245,0,.368.123.49.49a9.352,9.352,0,0,1,.245,3.185c0,.123-.123.245-.123.368a10.392,10.392,0,0,1-2.94,3.185,1.842,1.842,0,0,1-1.348.49H17.4a13.5,13.5,0,0,1-2.205-.245c-.245,0-.245-.123-.245-.368a33.023,33.023,0,0,0-.49-3.43c0-.123,0-.245.123-.245a37.606,37.606,0,0,0,3.063-3.185.45.45,0,0,1-.368-.123,23.012,23.012,0,0,1-2.94,3.063.45.45,0,0,1-.368.123c-1.593-.368-3.063-.735-4.655-1.225a.263.263,0,0,1-.245-.245,20.3,20.3,0,0,1-1.348-4.655.737.737,0,0,1,.123-.49A42.219,42.219,0,0,1,11.03,8.8h0c0-.368,0-.613,0-.98V7.575A16.259,16.259,0,0,0,9.928,5c-.123-.245-.123-.368,0-.49a12.3,12.3,0,0,1,2.45-1.96c.245-.123.368-.245.613-.123h.123a11.045,11.045,0,0,1,1.225-1.1A12.52,12.52,0,0,0,.372,10.515,12.836,12.836,0,0,0,9.438,26.074a12.518,12.518,0,0,0,15.436-9.065,10.039,10.039,0,0,0,.368-3.8C25.241,13.333,25.119,13.456,25,13.578ZM4.293,4.635A12.52,12.52,0,0,1,11.52,1.45h.123c.123,0,.735.368.735.49s0,.123-.123.123A15.968,15.968,0,0,0,9.56,4.39c-.123.245-.368.123-.613.245A10.5,10.5,0,0,0,5.028,5.86c-.123.123-.245,0-.368,0a2.678,2.678,0,0,0-.368-.613C4.048,5,4.048,4.88,4.293,4.635ZM.862,14.068a1.287,1.287,0,0,1-.613-1.1A12.874,12.874,0,0,1,3.435,5.493c.245-.123.245-.245.245-.245L3.8,5.37l.123.123a.947.947,0,0,1,.368,1.47,8.345,8.345,0,0,0-.858,3.43c0,.245-.123.368-.245.613a12.311,12.311,0,0,0-1.96,2.94C1.107,14.191,1.107,14.191.862,14.068Zm.49.49a.45.45,0,0,1,.123-.368,16.23,16.23,0,0,1,1.96-3.063.23.23,0,0,1,.368,0c1.1.368,2.328.858,3.43,1.348.123.123.245.123.245.368a27.68,27.68,0,0,0,1.348,4.533c.123.245.123.368-.123.49-.735.98-1.47,1.838-2.083,2.818-.123.123-.123.245-.245.123a9.9,9.9,0,0,1-3.308-1.348L2.7,19.091a11.935,11.935,0,0,1-1.225-4.41A.12.12,0,0,1,1.352,14.558ZM9.805,24.726c0,.123,0,.245-.123.245-.123.245,0,.49-.245.613-.123.123-.49-.123-.613-.123a12.231,12.231,0,0,1-6.248-4.533c0-.123-.123-.245-.123-.368v-.123c0-.245,0-.49.245-.613s.368.123.49.245a14.363,14.363,0,0,0,2.94,1.1.674.674,0,0,1,.613.368,16.022,16.022,0,0,0,2.94,2.818C9.805,24.481,9.928,24.6,9.805,24.726Zm9.065-.858a1.379,1.379,0,0,1-.613.98,12.107,12.107,0,0,1-5.513,1.225,18.276,18.276,0,0,1-2.573-.245.263.263,0,0,1-.245-.245,1.184,1.184,0,0,1,1.1-1.1,10.422,10.422,0,0,0,3.8-1.1h.245a7.032,7.032,0,0,0,3.553.245C18.871,23.624,18.871,23.624,18.871,23.869Z"
						transform="translate(0.022 1.028)"
						fill="url(#linear-gradient)"
					/>
					<path
						id="Path_58"
						data-name="Path 58"
						d="M9.708,7.4h0C8.605,8.5,7.5,9.728,6.523,10.83c-.123.123-.123.245-.123.49a33.306,33.306,0,0,0,1.348,4.655.263.263,0,0,0,.245.245c1.47.49,3.063.858,4.655,1.225a.45.45,0,0,0,.368-.123c.98-.98,1.96-1.96,2.94-3.063A7.943,7.943,0,0,1,9.708,7.4Z"
						transform="translate(1.467 2.429)"
						fill="#fefefe"
					/>
					<path
						id="Path_59"
						data-name="Path 59"
						d="M2.693,17.647A8.6,8.6,0,0,0,6,18.995c.245,0,.245,0,.245-.123.735-.98,1.348-1.96,2.083-2.818a.737.737,0,0,0,.123-.49A21.219,21.219,0,0,1,7.1,11.032c0-.245-.123-.245-.245-.368A26.655,26.655,0,0,0,3.55,9.317a.23.23,0,0,0-.368,0,16.23,16.23,0,0,0-1.96,3.063c0,.123-.123.245-.123.368v.123a13.084,13.084,0,0,0,1.225,4.41Q2.509,17.647,2.693,17.647Z"
						transform="translate(0.274 2.839)"
						fill="#fefefe"
					/>
					<path
						id="Path_60"
						data-name="Path 60"
						d="M15.085,13.145a37.606,37.606,0,0,1-3.063,3.185c-.123.123-.123.123-.123.245a33.022,33.022,0,0,1,.49,3.43c0,.245.123.245.245.368a6.783,6.783,0,0,0,2.205.245h.735a2.569,2.569,0,0,0,1.348-.49,14.665,14.665,0,0,0,2.94-3.185.45.45,0,0,0,.123-.368,13.97,13.97,0,0,0-.245-3.185c-.123-.368-.245-.49-.49-.49a9.326,9.326,0,0,1-2.573.368A6.472,6.472,0,0,1,15.085,13.145Z"
						transform="translate(2.705 3.666)"
						fill="#fefefe"
					/>
					<path
						id="Path_61"
						data-name="Path 61"
						d="M11.3,2.1a1.1,1.1,0,0,0-.613.123,13.231,13.231,0,0,0-2.45,1.96c-.245.245-.245.368-.123.613a16.259,16.259,0,0,1,1.1,2.573A8.488,8.488,0,0,1,11.3,2.1Z"
						transform="translate(1.835 1.236)"
						fill="#fefefe"
					/>
					<path
						id="Path_62"
						data-name="Path 62"
						d="M3.363,9.645a10.861,10.861,0,0,1,.858-3.43.947.947,0,0,0-.368-1.47L3.73,4.623,3.608,4.5c0,.123,0,.123-.123.245A12.138,12.138,0,0,0,.3,12.218a1.071,1.071,0,0,0,.613,1.1c.123.123.245.123.368-.123a12.311,12.311,0,0,1,1.96-2.94C3.24,10.013,3.363,9.89,3.363,9.645Z"
						transform="translate(0.094 1.776)"
						fill="#fefefe"
					/>
					<path
						id="Path_63"
						data-name="Path 63"
						d="M9.228,20.939a16.022,16.022,0,0,1-2.94-2.818c-.123-.245-.368-.245-.613-.368a14.364,14.364,0,0,1-2.94-1.1c-.123-.123-.368-.368-.49-.245A.936.936,0,0,0,2,17.019v.123c0,.123.123.245.123.368A12.231,12.231,0,0,0,8.37,22.041c.245.123.49.245.613.123s.123-.368.245-.613c0-.123,0-.245.123-.245C9.473,21.184,9.35,21.061,9.228,20.939Z"
						transform="translate(0.477 4.448)"
						fill="#fefefe"
					/>
					<path
						id="Path_64"
						data-name="Path 64"
						d="M3.534,5.175a2.678,2.678,0,0,1,.368.613c.123,0,.245.123.368,0a9.167,9.167,0,0,1,3.92-1.225.9.9,0,0,0,.735-.245,7.912,7.912,0,0,1,2.7-2.205.12.12,0,0,0,.123-.123,2.563,2.563,0,0,0-.735-.49h-.123a11.677,11.677,0,0,0-7.35,3.063C3.289,4.808,3.289,4.93,3.534,5.175Z"
						transform="translate(0.78 1.101)"
						fill="#fefefe"
					/>
					<path
						id="Path_65"
						data-name="Path 65"
						d="M16.8,19.545a6.938,6.938,0,0,1-3.553-.245H13a13.538,13.538,0,0,1-3.8,1.1,1.1,1.1,0,0,0-1.1,1.1c0,.245,0,.245.245.245A18.276,18.276,0,0,0,10.918,22,12.107,12.107,0,0,0,16.43,20.77a1.009,1.009,0,0,0,.613-.98C17.043,19.545,17.043,19.545,16.8,19.545Z"
						transform="translate(1.849 5.107)"
						fill="#fefefe"
					/>
					<path
						id="Path_66"
						data-name="Path 66"
						d="M18.41,13.015c0,.123-.123.123,0,.245a8.6,8.6,0,0,1,.368,3.553c0,.123,0,.123.123.123a.824.824,0,0,0,.858-.368,12.128,12.128,0,0,0,1.1-5.145V11.3A8.8,8.8,0,0,1,18.41,13.015Z"
						transform="translate(4.157 3.306)"
						fill="#fefefe"
					/>
					<ellipse
						id="Ellipse_9"
						data-name="Ellipse 9"
						cx="7.89"
						cy="7.89"
						rx="7.89"
						ry="7.89"
						transform="translate(11.542 1.131)"
						fill="#161616"
					/>
					<text
						id="P"
						transform="translate(24.551 14.5)"
						fill="#fff"
						fontSize="14.5"
						fontStyle="normal"
						fontFamily="Arial-BoldMT"
					>
						<tspan x="0" y="0">
							P
						</tspan>
					</text>
					<path
						id="Path_67"
						data-name="Path 67"
						d="M10.968,15.093,9.5,13.623l-3.553,3.43L2.515,13.5.923,14.97l3.43,3.553L.8,22.075l1.593,1.47,3.553-3.43,3.43,3.553,1.593-1.47L7.415,18.645Z"
						transform="translate(0.206 3.802)"
						fill="red"
					/>
				</svg>
			);
			break;
		case 'penalty-success':
			icon = (
				<svg
					{...svgProps}
					xmlns="http://www.w3.org/2000/svg"
					width="28.464"
					height="31"
					viewBox="0 0 28.464 31"
				>
					<path
						id="v_sign"
						d="M.9,17.05,9.918,21.7,29.364,0,10.623,31Z"
						transform="translate(-0.9)"
						fill="#47a336"
					/>
				</svg>
			);
			break;
		case 'penalty-fail':
			icon = (
				<svg
					{...svgProps}
					xmlns="http://www.w3.org/2000/svg"
					width="28.667"
					height="28.667"
					viewBox="0 0 28.667 28.667"
				>
					<path
						id="x_sign"
						d="M28.667,4.561l-4.3-4.3L14.333,10.033,4.561,0,.261,4.3l9.773,10.033L0,24.106l4.3,4.3,10.033-9.773,9.773,10.033,4.3-4.3L18.633,14.333Z"
						fill="red"
					/>
				</svg>
			);
			break;
		case 'field':
			icon = (
				<svg {...svgProps} xmlns="http://www.w3.org/2000/svg" width="367" height="552" viewBox="0 0 367 552">
					<g
						id="soccer_field_bg_desktop"
						data-name="soccer field bg / desktop"
						transform="translate(-57 -56)"
					>
						<path
							id="field_bg"
							data-name="field bg"
							d="M0,0H367V552H0Z"
							transform="translate(57 56)"
							fill="#b6d9bb"
						/>
						<path
							id="bench_bg"
							data-name="bench bg"
							d="M0,0H367V129H0Z"
							transform="translate(57 479)"
							fill="#cdd8ce"
						/>
						<g
							id="field_illusttation"
							data-name="field illusttation"
							transform="translate(424.121 56) rotate(90)"
							opacity="0.6"
						>
							<g id="gate_area" data-name="gate area" transform="translate(330 80.406)">
								<path
									id="Path_27"
									data-name="Path 27"
									d="M78.148,0H0V207.122H78.148"
									transform="translate(14.284 0)"
									fill="none"
									stroke="#fff"
									strokeWidth="2"
								/>
								<path
									id="Path_28"
									data-name="Path 28"
									d="M25.808,0H0V84.3H25.808"
									transform="translate(65.203 61.411)"
									fill="none"
									stroke="#fff"
									strokeWidth="2"
								/>
								<g
									id="Ellipse_6"
									data-name="Ellipse 6"
									transform="translate(38.025 100.467)"
									fill="#fff"
									stroke="#fff"
									strokeWidth="1"
								>
									<ellipse cx="3.096" cy="3.44" rx="3.096" ry="3.44" stroke="none" />
									<ellipse cx="3.096" cy="3.44" rx="2.596" ry="2.94" fill="none" />
								</g>
								<path
									id="Path_30"
									data-name="Path 30"
									d="M14.284,0a38.987,38.987,0,0,0,0,60.324"
									transform="translate(0 74.34)"
									fill="none"
									stroke="#fff"
									strokeWidth="2"
								/>
							</g>
							<g id="gate_area-2" data-name="gate area" transform="translate(92.432 287.528) rotate(180)">
								<path
									id="Path_27-2"
									data-name="Path 27"
									d="M78.148,0H0V207.122H78.148"
									transform="translate(14.284 0)"
									fill="none"
									stroke="#fff"
									strokeWidth="2"
								/>
								<path
									id="Path_28-2"
									data-name="Path 28"
									d="M27.229,0H0V84.3H27.229"
									transform="translate(65.203 61.411)"
									fill="none"
									stroke="#fff"
									strokeWidth="2"
								/>
								<path
									id="Path_30-2"
									data-name="Path 30"
									d="M14.284,0a38.987,38.987,0,0,0,0,60.324"
									transform="translate(0 74.34)"
									fill="none"
									stroke="#fff"
									strokeWidth="2"
								/>
							</g>
							<g id="mid_field" data-name="mid field" transform="translate(-30.85)">
								<g
									id="Ellipse_5"
									data-name="Ellipse 5"
									transform="translate(199.85 141.834)"
									fill="none"
									stroke="#fff"
									strokeWidth="2"
								>
									<circle cx="42.5" cy="42.5" r="42.5" stroke="none" />
									<circle cx="42.5" cy="42.5" r="41.5" fill="none" />
								</g>
								<rect
									id="Rectangle_10"
									data-name="Rectangle 10"
									width="2"
									height="367"
									transform="translate(240.881 0.121)"
									fill="#fff"
								/>
							</g>
							<rect
								id="Rectangle_755"
								data-name="Rectangle 755"
								width="367"
								height="2"
								transform="translate(421 367.121) rotate(-90)"
								fill="#fff"
							/>
						</g>
					</g>
				</svg>
			);
			break;

		case 'shirt':
			icon = (
				<svg {...svgProps} xmlns="http://www.w3.org/2000/svg" viewBox="0 0 22 22">
					<path d="M11,20.37c-5.46,0-6.49-.19-6.66-.29,0-.8,0-9.53,0-10.29l-.08-.12-.13,0a1.44,1.44,0,0,0-.69.31,1.89,1.89,0,0,1-.51.26A36,36,0,0,1,.8,6.72L.15,5.56A35.69,35.69,0,0,1,3.75,3.4a35.92,35.92,0,0,1,4-1.73l0,0a3,3,0,0,1,.55.43A4.52,4.52,0,0,0,11,3.45a4.52,4.52,0,0,0,2.67-1.39,3,3,0,0,1,.56-.43l0,0a35.45,35.45,0,0,1,4,1.73,37.06,37.06,0,0,1,3.59,2.16L21.2,6.72a36,36,0,0,1-2.08,3.5,1.89,1.89,0,0,1-.51-.26,1.44,1.44,0,0,0-.69-.31l-.13,0-.08.12c0,.55,0,5.25,0,8.06,0,1.14,0,2,0,2.23C17.49,20.18,16.46,20.37,11,20.37Z" />
					<path d="M18.32,3.29a35.3,35.3,0,0,0-4-1.74.09.09,0,0,0-.08-.05c-.17,0-.55.39-1.07.81a3.66,3.66,0,0,1-2.17,1,3.63,3.63,0,0,1-2.17-1c-.51-.42-.89-.81-1.06-.81a.09.09,0,0,0-.08.05,36.35,36.35,0,0,0-4,1.74C3.38,3.45-.11,5.38,0,5.56c.52.87,2.6,4.78,2.85,4.78s.88-.56,1.23-.56h.08c0,.78.06,9.81.06,10.33,0,.25,2.23.34,4.61.37h4.34c2.39,0,4.61-.12,4.61-.37,0-.53,0-9.55.06-10.33h.08c.35,0,.89.56,1.23.56S21.48,6.43,22,5.56C22.11,5.38,18.63,3.45,18.32,3.29Zm2.77,3.37c-.6,1.08-1.69,3-2,3.42a2.39,2.39,0,0,1-.4-.23,1.56,1.56,0,0,0-.76-.32.47.47,0,0,0-.17,0l-.17.24c0,.55,0,5.25,0,8.06,0,1,0,1.82,0,2.14a22.85,22.85,0,0,1-4.36.25H8.83A23.08,23.08,0,0,1,4.47,20c0-1.2,0-9.46,0-10.2l-.17-.24a.47.47,0,0,0-.17,0,1.56,1.56,0,0,0-.76.32,2.39,2.39,0,0,1-.4.23C2.6,9.7,1.51,7.74.91,6.66L.31,5.59c.54-.43,3-1.82,3.5-2.08a35,35,0,0,1,4-1.72h0a3.71,3.71,0,0,1,.46.37c.17.15.36.32.58.49A3.64,3.64,0,0,0,11,3.58a3.69,3.69,0,0,0,2.17-.94c.22-.17.41-.34.58-.49a3.69,3.69,0,0,1,.47-.37h0a34.51,34.51,0,0,1,4,1.72c.49.26,2.95,1.64,3.49,2.07Z" />
					<path
						className="b"
						d="M18.32,3.29a35.3,35.3,0,0,0-4-1.74c-.19-.41-1.66,1.77-3.32,1.77S7.88,1.14,7.69,1.55a36.35,36.35,0,0,0-4,1.74C3.38,3.45-.11,5.38,0,5.56c.52.87,2.6,4.78,2.85,4.78s1-.67,1.31-.55c0,.78.06,9.81.06,10.33,0,.32,3.8.38,6.78.38s6.78-.06,6.78-.38c0-.53,0-9.55.06-10.33.33-.12.94.55,1.31.55S21.48,6.43,22,5.56c.11-.18-3.37-2.11-3.68-2.27Z"
						fill={color}
					/>
					<path
						className="a"
						d="M8.83,2.64v17.6h4.34V2.64A3.69,3.69,0,0,1,11,3.58,3.64,3.64,0,0,1,8.83,2.64Z"
						fill={secondaryColor}
					/>
				</svg>
			);
			break;
		case 'subtitute-out':
			icon = (
				<svg
					{...svgProps}
					xmlns="http://www.w3.org/2000/svg"
					width="14.422"
					height="21.231"
					viewBox="0 0 14.422 21.231"
				>
					<path
						id="substitute_out"
						d="M4.7,11,11,20.9,17.3,11H12.8V1.1H9.2V11Z"
						transform="translate(-3.789 -0.6)"
						fill="#f32c2c"
						stroke="#000"
						strokeWidth="1"
					/>
				</svg>
			);
			break;
		case 'subtitute-in':
			icon = (
				<svg
					{...svgProps}
					xmlns="http://www.w3.org/2000/svg"
					width="14.422"
					height="21.231"
					viewBox="0 0 14.422 21.231"
				>
					<path
						id="substitute_in"
						d="M4.7,11,11,1.1,17.3,11H12.8v9.9H9.2V11Z"
						transform="translate(-3.789 -0.169)"
						fill="#4eba3a"
						stroke="#000"
						strokeWidth="1"
					/>
				</svg>
			);
			break;
		case 'field-mobile':
			icon = (
				<svg {...svgProps} xmlns="http://www.w3.org/2000/svg" width="180" height="312" viewBox="0 0 180 312">
					<g
						id="soccer_filed_bg_mobile"
						data-name="soccer filed bg / mobile"
						transform="translate(-7366 -1085)"
					>
						<path
							id="bench_bg"
							data-name="bench bg"
							d="M0,0H180V66H0Z"
							transform="translate(7366 1331)"
							fill="#cdd8ce"
						/>
						<path
							id="field_bg"
							data-name="field bg"
							d="M0,0H180V244.667H0Z"
							transform="translate(7366 1085)"
							fill="#b6d9bb"
						/>
						<g
							id="field_illusttation"
							data-name="field illusttation"
							transform="translate(7546 1085) rotate(90)"
							opacity="0.6"
						>
							<g id="gate_area" data-name="gate area" transform="translate(202.631 41.588)">
								<path
									id="Path_27"
									data-name="Path 27"
									d="M36.667,0H0V97.182H36.667"
									transform="translate(6.702)"
									fill="none"
									stroke="#fff"
									strokeWidth="1"
								/>
								<path
									id="Path_28"
									data-name="Path 28"
									d="M12.109,0H0V39.554H12.109"
									transform="translate(30.594 28.814)"
									fill="none"
									stroke="#fff"
									strokeWidth="1"
								/>
								<path
									id="Path_30"
									data-name="Path 30"
									d="M6.7,0a18.293,18.293,0,0,0,0,28.3"
									transform="translate(0 34.881)"
									fill="none"
									stroke="#fff"
									strokeWidth="1"
								/>
							</g>
							<g id="gate_area-2" data-name="gate area" transform="translate(43.369 138.771) rotate(180)">
								<path
									id="Path_27-2"
									data-name="Path 27"
									d="M36.667,0H0V97.182H36.667"
									transform="translate(6.702 0)"
									fill="none"
									stroke="#fff"
									strokeWidth="1"
								/>
								<path
									id="Path_28-2"
									data-name="Path 28"
									d="M12.776,0H0V39.554H12.776"
									transform="translate(30.594 28.814)"
									fill="none"
									stroke="#fff"
									strokeWidth="1"
								/>
								<path
									id="Path_30-2"
									data-name="Path 30"
									d="M6.7,0a18.293,18.293,0,0,0,0,28.3"
									transform="translate(0 34.881)"
									fill="none"
									stroke="#fff"
									strokeWidth="1"
								/>
							</g>
							<g id="mid_field" data-name="mid field" transform="translate(103.232)">
								<g
									id="Ellipse_5"
									data-name="Ellipse 5"
									transform="translate(0 70.413)"
									fill="none"
									stroke="#fff"
									strokeWidth="1"
								>
									<circle cx="19.941" cy="19.941" r="19.941" stroke="none" />
									<circle cx="19.941" cy="19.941" r="19.441" fill="none" />
								</g>
								<rect
									id="Rectangle_10"
									data-name="Rectangle 10"
									width="0.938"
									height="180"
									transform="translate(19.252)"
									fill="#fff"
								/>
							</g>
							<rect
								id="Rectangle_755"
								data-name="Rectangle 755"
								width="180"
								height="1"
								transform="translate(245 180) rotate(-90)"
								fill="#fff"
							/>
						</g>
					</g>
				</svg>
			);
			break;

		default:
			break;
	}

	return (
		<i className={classNames(css.icon, className)} {...iconProps}>
			{icon}
		</i>
	);
};

// case '':
// icon = ()
// break;

Icon.defaultProps = {
	className: '',
	width: 34,
	height: 34,
	color: '#111',
	secondaryColor: 'none',
	onClick: () => {},
};

export { Icon };
